import { Replay } from '@mui/icons-material'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RequestStepAction } from '@omnea-app/core/stages/utilEnums'
import { ConfirmDialog } from '@omnea-app/omui/ConfirmDialog'
import { useRequestActions } from '../../timeline-overview/useRequestActions'

interface Props {
  requestId: string
  onClose?: () => void
}

export const ReopenMenuItem = ({ requestId, onClose }: Props) => {
  const { t } = useTranslation('requests')
  const { onAction } = useRequestActions({ requestId })
  const handleConfirm = async () => {
    try {
      await onAction(undefined, RequestStepAction.ROLLBACK)
      closeDialog()
    } catch {
      enqueueSnackbar(t('reopen.reopen-unsuccessful'), { variant: 'error' })
    }
  }
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const closeDialog = () => setIsDialogOpen(false)
  const openDialog = () => {
    setIsDialogOpen(true)
    onClose?.()
  }

  return (
    <>
      <MenuItem onClick={openDialog}>
        <ListItemIcon>
          <Replay />
        </ListItemIcon>
        <ListItemText>{t('manage-request.reopen')}</ListItemText>
      </MenuItem>
      <ConfirmDialog
        open={isDialogOpen}
        onClose={closeDialog}
        onConfirm={handleConfirm}
        title={t('reopen.confirm')}
        bodyTexts={[t('reopen.confirm-description'), t('reopen.confirm-subtext')]}
        actions={[
          { variant: 'contained', color: 'secondary', text: t('reopen.back'), action: 'cancel' },
          { variant: 'contained', color: 'error', text: t('reopen.forward'), action: 'confirm' },
        ]}
      />
    </>
  )
}
